import React from "react";
import { Label } from "~/components/ui/label";
import { Input } from "~/components/ui/input";

interface Props {
  label: string;
  name: string;
  defaultValue?: string | number;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  inputType?: "email" | "password" | "text" | "number" | "datetime-local";
  required?: boolean;
  autoComplete?: string;
  error?: boolean;
  helperText?: string;
  startAdornment?: React.ReactNode;
  placeholder?: string;
  min?: number | string;
  max?: number | string;
  step?: number | string;
  infoText?: string;
}

export default function InputComponent({
  label,
  name,
  defaultValue,
  inputType = "text",
  autoComplete,
  required = false,
  onBlur,
  onChange,
  error = false,
  helperText,
  startAdornment,
  placeholder,
  min,
  max,
  step,
  infoText,
}: Props) {
  return (
    <div className="grid gap-3">
      <Label htmlFor={name}>{label}</Label>
      <Input
        placeholder={placeholder}
        id={name}
        defaultValue={defaultValue}
        name={name}
        type={inputType}
        autoComplete={autoComplete}
        required={required}
        onChange={onChange}
        onBlur={onBlur}
        min={min}
        max={max}
        step={step}
        infoText={infoText}
      />
      {helperText && (
        <div
          className={`mt-1 text-sm ${
            error ? "text-red-500" : "text-white"
          } h-5`}
        >
          {helperText}
        </div>
      )}
    </div>
  );
}
